const SELECT_REQUEST = 'locations/select/request'
const SELECT_SUCCESS = 'locations/select/success'
const SELECT_FAILURE = 'locations/select/failure'

export { SELECT_REQUEST, SELECT_SUCCESS, SELECT_FAILURE }
